export default __webpack_public_path__ + "static/media/chair.f909e231.glb";